import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import PropTypes from "prop-types";
import { Typography, Divider, Flex, Button } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import styles from "./ExperienceBooking.module.css";
import { routes } from "router";
import GuestsSelector from "./GuestSelector";
import DateSelector from "./DateSelector";
import DropdownSelector from "./DropDownSelector";
const { Text } = Typography;


const BookingDetailCard = ({ bookNow, trip, bookingButtonVisible, activeTab, bookingErrors, setBookingErrors }) => {
    const navigate = useNavigate()
    const { uuid, id } = useParams()
    const location = useLocation()
    const [t] = useTranslation()
    const [date, setDate] = useState(null);
    const [tripLength, setTripLength] = useState("");
    const [timeSlot, setTimeSlot] = useState("");
    const [counts, setCounts] = useState({
        adults: 0,
        children: 0,
        infants: 0,
        passengers: 0,
    });
    const isBookNow = location?.pathname?.includes("/experience_detail")

    const infoData = [
        { label: "Date", value: "Add Date" },
        { label: "Guests", value: "Add Guests" },
        { label: "Trip Length", value: "Add Trip Length" },
        { label: "Time", value: "Add Time" },
    ];

    const updateBookingSelection = useCallback((key, value) => {
        const current = JSON.parse(localStorage.getItem("bookingSelections") || "{}");
        localStorage.setItem("bookingSelections", JSON.stringify({ ...current, [key]: value }));

        if (setBookingErrors) {
            setBookingErrors(prev => ({ ...prev, [key]: false }));
        }
    }, [setBookingErrors]);

    const handleDateChange = useCallback((value) => {
        setDate(value);
        updateBookingSelection("date", value ? value.toISOString() : null);
    }, [updateBookingSelection]);

    const handleTripLengthChange = useCallback((value) => {
        setTripLength(value);
        updateBookingSelection("tripLength", value);
    }, [updateBookingSelection]);

    const handleTimeSlotChange = useCallback((value) => {
        setTimeSlot(value);
        updateBookingSelection("timeSlot", value);
    }, [updateBookingSelection]);

    const handleGuestsChange = useCallback((newCounts) => {
        setCounts(newCounts);
        updateBookingSelection("counts", newCounts);
    }, [updateBookingSelection]);

    useEffect(() => {
        const stored = localStorage.getItem("bookingSelections");
        if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed.date) setDate(dayjs(parsed.date));
            if (parsed.tripLength) setTripLength(parsed.tripLength);
            if (parsed.timeSlot) setTimeSlot(parsed.timeSlot);
            if (parsed.counts) setCounts(parsed.counts);
        }
    }, []);

    return (
        <div className="p-xl" style={{ backgroundColor: "#F9FBFC" }}>
            <Text style={{ fontSize: "18px", fontWeight: 600 }}>{`${bookNow ? trip?.title : "From $" + trip?.price_per_person}`}</Text>
            <Flex vertical gap={8} className="py-xl">
                {!bookNow ?
                    infoData?.map((data, index) => {
                        return (
                            <Flex justify="space-between" align="center" className={`${styles.cardDetailItems} p-s rounded-s`} key={index + 1}>
                                <Text>
                                    {data?.label}
                                </Text>
                                <Text>
                                    {data?.value}
                                </Text>
                            </Flex>
                        )
                    }) :
                    <>
                        <DateSelector value={date} onChange={handleDateChange} activeTab={activeTab} error={bookingErrors?.date} />
                        <GuestsSelector counts={counts} setCounts={handleGuestsChange} activeTab={activeTab} error={bookingErrors?.counts} setBookingErrors={setBookingErrors} />
                        <DropdownSelector value={tripLength} onChange={handleTripLengthChange} label="Trip Length"
                            options={["1 hr", "2 hrs", "3 hrs", "4 hrs"]} placeholder="Add Trip Length" activeTab={activeTab} error={bookingErrors?.tripLength} />
                        <DropdownSelector placeholder="Add Time" value={timeSlot} onChange={handleTimeSlotChange} label="Time" activeTab={activeTab} error={bookingErrors?.timeSlot}
                            options={[
                                "4:30 PM - 7:30 PM",
                                "8:30 PM - 9:30 PM",
                                "9:30 PM - 10:30 PM",
                                "10:30 PM - 6 AM",
                            ]} />
                    </>
                }
            </Flex>
            {bookNow &&
                <>
                    <Flex vertical gap={4}>
                        <Flex align="center" justify="space-between">
                            <Text>Solo Explorer x 3</Text>
                            <Text>$300</Text>
                        </Flex>
                        <Flex align="center" justify="space-between">
                            <Text>Tax & Fees</Text>
                            <Text>$300</Text>
                        </Flex>
                    </Flex>
                    <Divider />
                    <Flex align="center" justify="space-between">
                        <Text strong style={{ fontWeight: 600 }}>Total</Text>
                        <Text style={{ fontWeight: 600 }}>$300</Text>
                    </Flex>
                </>
            }
            {bookingButtonVisible &&
                <>
                    <Button classNames={styles?.bookButton} type="primary" disabled={!bookNow} className={styles.bookButton} onClick={() => {
                        if (isBookNow) {
                            navigate(routes.embeddedExperienceBooking({ uuid: uuid, id: id }))
                        }
                    }}>Book Now</Button>
                    <Flex justify="center" style={{ marginTop: "10px" }}>
                        <Text style={{ fontSize: "12px" }}>{t("webIntegration.payment_info")}</Text>
                    </Flex>
                </>
            }
        </div>
    )
}

BookingDetailCard.propTypes = {
    bookNow: PropTypes.bool,
    trip: PropTypes.shape({
        price_per_person: PropTypes.number,
        title: PropTypes.string
    }),
    bookingButtonVisible: PropTypes.bool,
    activeTab: PropTypes.number,
    bookingErrors: PropTypes?.object,
    setBookingErrors: PropTypes.func
};

export default BookingDetailCard


